import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthContext";
import LanguageSwitcher from "../languageSwitcher/LanguageSwitcher";
import NotificationDropdown from "./NotificationDropdown";
import {
  HiChevronDoubleLeft,
  HiChevronDoubleRight,
  HiLogout,
  HiLogin
} from 'react-icons/hi';
import "./navbar.scss"

interface NavbarProps {
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
}

const Navbar = React.memo(({ isSidebarOpen, onToggleSidebar }: NavbarProps) => {
  console.log('🔄 Navbar component rendering');
  const { t } = useTranslation();
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();

  const logOut = async () => {
    // Show confirmation dialog
    const confirmed = window.confirm(t('navbar.logoutConfirmMessage'));

    if (!confirmed) {
      return;
    }

    try {
      await logout();
      // showSuccessToast(t('navbar.logoutSuccess'));
      navigate("/auth/login");
    } catch (error) {
      console.error('Logout error:', error);
      // showErrorToast(t('navbar.logoutError'));
    }
  }

  return (
    <header className="navbar p-0">
      <div className="navbar-left mt-0">
        <button
          className="sidebar-toggle-btn"
          onClick={onToggleSidebar}
          type="button"
          aria-label="Toggle sidebar"
          title="Toggle sidebar"
        >
          {isSidebarOpen ? <HiChevronDoubleLeft className="toggle-icon" /> : <HiChevronDoubleRight className="toggle-icon" />}
        </button>
        <div className="logo">
          <img src="/logo.png" alt="9AR Logo" className="logo-img" />
          {/* <span>{t('navbar.sar')}</span> */}
        </div>
      </div>

      {/* <div className="navbar-center">
        <div className="search-container">
          <div className="search-input-wrapper">
            <HiSearch className="search-icon" />
            <input
              type="text"
              placeholder={t('navbar.search')}
              className="search-input"
            />
          </div>
        </div>
      </div> */}

      <div className="navbar-right">
        <div className="action-buttons">
          {/* <button className="action-btn" title={t('navbar.apps')}>
            <HiViewGrid className="action-icon" />
          </button> */}

          {/* <button className="action-btn" title={t('navbar.expand')}>
            <HiArrowsExpand className="action-icon" />
          </button> */}

          <NotificationDropdown />

          <LanguageSwitcher />

          <div className="user-menu">
            {isAuthenticated ? (
              <div className="user-profile">
                <div className="user-avatar">
                  <img src="/noavatar.png" alt={t('navbar.userAvatar')} />
                  <div className="user-status"></div>
                </div>
                <div className="user-info">
                  <span className="user-name">{user?.name || t('navbar.admin')}</span>
                  <span className="user-role">{user?.role || t('navbar.administrator')}</span>
                </div>
                <button className="logout-btn" onClick={logOut} title={t('navbar.logout')}>
                  <HiLogout className="logout-icon" />
                </button>
              </div>
            ) : (
              <Link to="/auth/login" className="login-btn">
                <HiLogin className="login-icon" />
                <span>{t('navbar.login')}</span>
              </Link>
            )}
          </div>

          {/* <button className="action-btn settings-btn" title={t('navbar.settings')}>
            <HiCog className="action-icon" />
          </button> */}
        </div>
      </div>
    </header>
  );
});

Navbar.displayName = 'Navbar';
export default Navbar;
